import { Wrench, ShieldCheck, Zap, Battery, Cpu, Gauge, Cog, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const items = [
  { icon: ShieldCheck, title: "Garantie partener", text: "Onoram garantia tuturor trotinetelor Kukirin cumparate de pe trotinete-ieftine.ro. Proces simplu, fara surprize." },
  { icon: Battery, title: "Diagnoza si inlocuire baterie", text: "Verificam fiecare celula, BMS si controller-ul. Inlocuim baterii originale si pe masura." },
  { icon: Cpu, title: "Reparatii controller", text: "Erori firmware, controller ars, conectica - rezolvate in atelier de specialisti." },
  { icon: Zap, title: "Motoare hub", text: "Bobinaje, rulmenti, magnet drift sau cabluri arse - reconditionare completa." },
  { icon: Gauge, title: "Frane si suspensie", text: "Servicing hidraulic, placute, suspensie fata/spate - calibrate pentru drumul tau." },
  { icon: Cog, title: "Tuning si firmware", text: "Configurari personalizate viteza, autonomie, limita motor pe responsabilitatea ta." },
  { icon: Wrench, title: "Reparatii cadru", text: "Surub, lagar pivot, suduri, balamale - readucem cadrul la specificatii." },
  { icon: Sparkles, title: "Detailing & upgrade-uri", text: "Grip-uri, anvelope, accesorii, lumini, suporturi telefon - personalizam." },
];

export default function ServicesPage() {
  return (
    <div data-testid="services-page" className="text-white">
      <section className="relative border-b border-neutral-900 py-20 px-6 lg:px-10">
        <div className="absolute inset-0 kk-grid-bg opacity-40" />
        <div className="relative max-w-7xl mx-auto">
          <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">// Servicii</div>
          <h1 className="font-display text-5xl sm:text-7xl uppercase leading-none">
            Ce stim sa <span className="text-[#00E5FF]">facem.</span>
          </h1>
          <p className="text-neutral-400 mt-6 max-w-2xl">
            Service specializat 100% pe trotinete Kukirin. Diagnoza gratuita la prima vizita.
          </p>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => (
            <div key={i} data-testid={`service-item-${i}`} className="bg-neutral-950 border border-neutral-800 hover:border-[#00E5FF] p-6 transition-all group">
              <div className="w-11 h-11 bg-[#00E5FF]/10 border border-[#00E5FF]/30 group-hover:bg-[#00E5FF] flex items-center justify-center mb-4 transition-colors">
                <it.icon className="w-5 h-5 text-[#00E5FF] group-hover:text-black" />
              </div>
              <h3 className="font-display text-lg uppercase mb-2 leading-tight">{it.title}</h3>
              <p className="text-sm text-neutral-400">{it.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#00E5FF] text-black p-10 lg:p-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div>
            <div className="text-xs uppercase tracking-widest font-bold mb-2">Procedura simpla</div>
            <h3 className="font-display text-3xl lg:text-5xl uppercase leading-none">Lasi trotineta, primesti SMS cand e gata.</h3>
          </div>
          <Link to="/programare" data-testid="services-cta-booking" className="bg-black text-white font-semibold px-7 py-4 uppercase tracking-wider text-sm hover:bg-neutral-900 transition-colors whitespace-nowrap">
            Fa o programare
          </Link>
        </div>
      </section>
    </div>
  );
}
